import config from 'cio/config/environment';
import { OAuthOpenOptions, OAuthProvider, Provider } from 'cio/utils/oauth';

interface OpenOptions extends OAuthOpenOptions {
  additionalGrant?: boolean;
}

export default class GoogleSheetsOauth extends OAuthProvider {
  name = Provider.GoogleSheets;
  baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
  clientId = config.oAuth.googleSheets.clientId;
  scope = 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email';
  extraParams = {
    access_type: 'offline',
    include_granted_scopes: true,
    prompt: 'consent',
  };

  async open(options: OpenOptions = {}) {
    let dynamicParams: Record<string, string> = {};

    if (options?.additionalGrant === true) {
      dynamicParams.scope = 'https://www.googleapis.com/auth/drive.file';
    }

    return super.open({ ...options, ...dynamicParams });
  }
}
